export default __webpack_public_path__ + "static/media/PersImg22.fe306180.jpg";